import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@kss/auth';

/**
 * `/login` forwards to the SINGLE canonical login — the panel's full-page
 * form at `/panel/login` (served by the panel SPA). Previously `/login`
 * opened the marketing-site modal, which meant users saw two different login
 * screens (`/login` modal vs `/panel/login` form). Now there is one.
 *
 * `/panel/login` is a separate SPA, so this is a hard navigation, not a
 * React-Router redirect. Authenticated users skip straight to their
 * originally-requested panel page.
 */
export default function Login() {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const requestedFrom = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;
  const target = requestedFrom && requestedFrom.startsWith('/panel') ? requestedFrom : '/panel/dashboard';

  useEffect(() => {
    if (isAuthenticated) return;
    // Hard navigation — the panel login form lives in the panel SPA under /panel/.
    window.location.replace('/panel/login');
  }, [isAuthenticated]);

  if (isAuthenticated) return <Navigate to={target} replace />;
  return null;
}
